// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qRO92iYtjMQHgPwR4EA6 {

    margin-left: 3rem;

    display: flex;

    flex-direction: column
}

.u_b317hNapmIw_HsV9pg {

    display: flex;

    justify-content: flex-end
}

.headingText .ant-divider-inner-text {

    font-family: Noto Sans !important;

    font-size: 18px !important;

    font-weight: 600 !important
}

.rTtn_VbFnwrMbR1ut7zt {

    --tw-border-opacity: 1 !important;

    border-color: rgb(228 229 231 / var(--tw-border-opacity, 1)) !important
}

.VZpfhtO9dNwT8jTyGGvp {

    height: 38px !important;

    width: 39px !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important
}

.cHKpsRkZ3eh8wWqanStw {

    display: flex;

    flex-direction: column;

    row-gap: 1.75rem
}

.htcH08HEOMGSyn1nx4lq {

    width: 100%
}

.vRvot7cmmlQnjifVcODp {

    display: flex;

    flex-wrap: wrap;

    row-gap: 2rem
}

.N3TfZ2lKKN8rZnUXVX6P {

    height: auto;

    width: 45%
}

.HEK8xFAt7Q8G__fy1nZ5 {

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 400;

    --tw-text-opacity: 1;

    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.B2dCfKyWB33vUica4Gks {

    margin-top: 0.5rem;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 500
}

.hNRAYnObrBQud0QD4GbL {

    font-family: Noto Sans;

    font-size: 1.125rem;

    line-height: 1.75rem;

    --tw-text-opacity: 1;

    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/components/Account/Address/Address.module.css"],"names":[],"mappings":"AACE;;IAAA,iBAA0B;;IAA1B,aAA0B;;IAA1B;AAA0B;;AAI1B;;IAAA,aAAuB;;IAAvB;AAAuB;;AAIvB;;IAAA,iCAAoC;;IAApC,0BAAoC;;IAApC;AAAoC;;AAIpC;;IAAA,iCAA2B;;IAA3B;AAA2B;;AAI3B;;IAAA,uBAAkD;;IAAlD,sBAAkD;;IAAlD,6BAAkD;;IAAlD;AAAkD;;AAIlD;;IAAA,aAA4B;;IAA5B,sBAA4B;;IAA5B;AAA4B;;AAI5B;;IAAA;AAAa;;AAIb;;IAAA,aAA6B;;IAA7B,eAA6B;;IAA7B;AAA6B;;AAI7B;;IAAA,YAAqB;;IAArB;AAAqB;;AAIrB;;IAAA,mBAAwC;;IAAxC,oBAAwC;;IAAxC,gBAAwC;;IAAxC,oBAAwC;;IAAxC;AAAwC;;AAIxC;;IAAA,kBAA+B;;IAA/B,mBAA+B;;IAA/B,oBAA+B;;IAA/B;AAA+B;;AAI/B;;IAAA,sBAAuC;;IAAvC,mBAAuC;;IAAvC,oBAAuC;;IAAvC,oBAAuC;;IAAvC;AAAuC","sourcesContent":[".mainContainer {\n  @apply flex flex-col ml-12;\n}\n\n.headingSection {\n  @apply flex justify-end;\n}\n\n:global(.headingText .ant-divider-inner-text) {\n  @apply !text-h4 !font-h4 !font-inter;\n}\n\n.headingText {\n  @apply !border-dividerColor;\n}\n\n.editButton {\n  @apply !bg-activeMenuItemColor !h-[38px] !w-[39px];\n}\n\n.personalInfoSection {\n  @apply flex flex-col gap-y-7;\n}\n\n.sectionBlock {\n  @apply w-full;\n}\n\n.addressFields {\n  @apply flex flex-wrap gap-y-8;\n}\n\n.singleInfoWrapper {\n  @apply w-[45%] h-auto;\n}\n\n.infoTitle {\n  @apply text-sm font-normal text-gray-400;\n}\n\n.info {\n  @apply text-sm font-medium mt-2;\n}\n\n.dividerText {\n  @apply text-lg font-inter text-gray-500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `qRO92iYtjMQHgPwR4EA6`,
	"headingSection": `u_b317hNapmIw_HsV9pg`,
	"headingText": `rTtn_VbFnwrMbR1ut7zt`,
	"editButton": `VZpfhtO9dNwT8jTyGGvp`,
	"personalInfoSection": `cHKpsRkZ3eh8wWqanStw`,
	"sectionBlock": `htcH08HEOMGSyn1nx4lq`,
	"addressFields": `vRvot7cmmlQnjifVcODp`,
	"singleInfoWrapper": `N3TfZ2lKKN8rZnUXVX6P`,
	"infoTitle": `HEK8xFAt7Q8G__fy1nZ5`,
	"info": `B2dCfKyWB33vUica4Gks`,
	"dividerText": `hNRAYnObrBQud0QD4GbL`
};
export default ___CSS_LOADER_EXPORT___;
